import { Link } from "react-router-dom";
import styles from "./welcome.module.css";

export default function Welcome() {
    return(
        <div className={styles.container}>
            <h1>Welcome to Marketplace</h1>
            <p>Your account is now created and confirmed. Now you can login to advertise your alternatives.</p>
            <Link to="/sign-in" className="button button_inverted">Sign in</Link>
        </div>
    )
}